module.exports = __webpack_public_path__ + "img/menu_other.afb4b8cc.png";